const { version } = require("../package.json");

export const env = process.env.NODE_ENV || "production";
const isProd = env === "production";

const baseUrls = {
  dev: "https://hqprgs2tyk.execute-api.us-east-1.amazonaws.com/production", // prod
  local: "http://localhost:8000",
};

const config = {
  version,
  baseUrl: baseUrls[env] || baseUrls.dev,
  googleAnalytics: {
    key: "UA-133416348-1",
  },
};

const prodConfig = {
  ...config,
  // googleAnalytics: {
  //   key: "UA-133416348-1",
  // },
  baseUrl: "https://hqprgs2tyk.execute-api.us-east-1.amazonaws.com/production", // prod
};

export default isProd ? prodConfig : config;
